import {
    AggregationModel,
    AggregationResponse,
    ApiResultFailed,
    LinearAlertModel,
    GrouppedQueryModel,
    HttpResponse,
    Operation,
    RequestParams,
} from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';

export class LinearAlertsDataService implements CrudService<LinearAlertModel, LinearAlertModel> {
    getAll(query: CrudDataQuery<LinearAlertModel>): Promise<CrudEnumerableResponse<LinearAlertModel>> {
        return ApiService.api.getLinearAlertBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<LinearAlertModel>): Promise<CrudEnumerableResponse<LinearAlertModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<LinearAlertModel>> {
        return ApiService.api.getLinearAlertById(id, params);
    }

    create(item: LinearAlertModel, params?: RequestParams): Promise<CrudResponse<LinearAlertModel>> {
        return ApiService.api.insertLinearAlert(item, params);
    }

    update(item: LinearAlertModel, params?: RequestParams): Promise<LinearAlertModel> {
        return ApiService.api.updateLinearAlert(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<LinearAlertModel> {
        return ApiService.api.patchLinearAlert(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<LinearAlertModel>): Promise<CrudEnumerableResponse<LinearAlertModel>> {
        return ApiService.api.deleteLinearAlerts(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationLinearAlert(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<LinearAlertModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: LinearAlertModel, params?: RequestParams): Promise<CrudResponse<LinearAlertModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getLinearAlertGroupped(query, params);
    }
}
